// extracted by mini-css-extract-plugin
export default {"ebookForm_Btn":"ebook-form--ebookForm_Btn"};